import { COOKIES_POLICY_KEY } from '../constants/storageKeys'

/** '' = never seen · 'informed' = shown, undecided · 'allowed'/'declined' = decision made. */
export type TCookieConsent = '' | 'informed' | 'allowed' | 'declined'

const isKnownConsent = (value: string): value is TCookieConsent =>
    value === 'informed' || value === 'allowed' || value === 'declined'

/** Raw unquoted string shared with the nextjs tier — `@muse-web/storages` would JSON-parse it. */
export const getCookiesPolicy = (): TCookieConsent => {
    if (typeof window === 'undefined') {
        return ''
    }

    try {
        const raw = (window.localStorage.getItem(COOKIES_POLICY_KEY) ?? '').replace(/['"]+/g, '')

        return isKnownConsent(raw) ? raw : ''
    } catch {
        return ''
    }
}

export const setCookiesPolicy = (consent: Exclude<TCookieConsent, ''>): void => {
    if (typeof window === 'undefined') {
        return undefined
    }

    try {
        return window.localStorage.setItem(COOKIES_POLICY_KEY, consent)
    } catch {
        return undefined
    }
}
